import {ChangeDetectionStrategy, Component, computed, effect, inject, NgZone, signal} from '@angular/core';
import {SearchWidgetDataItem} from 'src/app/types/SearchWidgetDataItem';
import {ElementToggleEnum} from 'src/app/enums/CssClassEnums';
import {SearchService} from '../../../../services/search/search.service';
import {SearchWidgetV3StateService} from '../../services/search-widget-v3-state.service';

enum AnimationClass {
  CLOSED = 'closed',
  NORMAL = 'normal',
}

@Component({
  selector: 'app-search-places-mobile-panel-v3',
  templateUrl: './search-places-mobile-panel-v3.component.html',
  styleUrls: ['./search-places-mobile-panel-v3.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchPlacesMobilePanelV3Component {
  public isWidgetVisible = signal<boolean>(false);
  public animationClass = signal<AnimationClass>(AnimationClass.CLOSED);
  public hierarchyLevel = signal<number>(0);
  protected readonly elementToggleEnum = ElementToggleEnum;
  protected currentItems = signal<Array<SearchWidgetDataItem>>([]);
  protected navigation = signal<Array<Array<SearchWidgetDataItem>>>([]);
  private searchService = inject(SearchService);
  private widgetState = inject(SearchWidgetV3StateService);
  private mobilePlacesPanelOpen = this.widgetState.mobilePlacesPanelOpen;
  private places = this.searchService.places;
  protected items = computed(() => {
    return this.places() ? this.places().places : [];
  });

  constructor(private ngZone: NgZone) {
    effect(
      () => {
        this.handleMobilePlacesPanelOpen(this.mobilePlacesPanelOpen());
      },
      {allowSignalWrites: true},
    );
  }

  public navigateBack(): void {
    // children implement navigate back logic
  }

  protected onCloseClick(): void {
    this.closeThisPanel();
  }

  private closeThisPanel(): void {
    // TODO -children: implement close panel logic
  }

  private handleOpenPanel(result: boolean): void {
    if (result === false) {
      this.animationClass.set(AnimationClass.CLOSED);
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.isWidgetVisible.set(false);
          });
        }, 500);
      });
    } else {
      this.isWidgetVisible.set(true);
      this.animationClass.set(AnimationClass.CLOSED);

      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.ngZone.run(() => {
            this.animationClass.set(AnimationClass.NORMAL);
          });
        }, 50);
      });
    }
  }

  private handleMobilePlacesPanelOpen(result: boolean): void {
    this.handleOpenPanel(result);
    this.currentItems.set(this.items());
    this.navigation.set([]);
  }
}
